module.exports = __webpack_public_path__ + "img/1800.f9db8446.jpg";